import { Link } from 'react-router-dom';

const navLinks = [
  { label: '關於鳴箏', href: '/about' },
  { label: '教學方式', href: '/teaching' },
  { label: '課程路徑', href: '/courses' },
  { label: '古箏買賣', href: '/instrument' },
  { label: '鳴箏筆記', href: '/notes' },
  { label: '聯絡諮詢', href: '/contact' },
];

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#2c2420] text-[#f0e8d8] relative">
      {/* Main Footer Content */}
      <div className="w-full px-6 md:px-12 lg:px-20 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img
              src="https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/e33f307f87b4fb2fac52df6e599e8335.png"
              alt="鳴箏 Logo"
              className="h-12 w-auto object-contain mb-6 brightness-0 invert opacity-90"
            />
            <p className="text-[0.9375rem] leading-relaxed text-[#d4c8b4] mb-4 max-w-xs">
              古箏教學・陪伴式學習・選箏諮詢
            </p>
            <p className="text-[0.875rem] leading-loose text-[#baa890] max-w-sm">
              這裡不急著讓你學會什麼。<br />
              我們更在意的是，你是否感到安心、<br />
              願意長久地與這個聲音相處。
            </p>
            {/* Social */}
            <div className="flex flex-wrap items-center gap-3 mt-6">
              <a
                href="https://line.me"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-[#d4c8b4]/60 text-[#d4c8b4] hover:border-[#06C755] hover:text-[#06C755] transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-line-fill text-base"></i>
                <span className="text-[0.8125rem]">LINE@</span>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-[#d4c8b4]/60 text-[#d4c8b4] hover:border-[#c8607a] hover:text-[#c8607a] transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-instagram-line text-base"></i>
                <span className="text-[0.8125rem]">Instagram</span>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-[#d4c8b4]/60 text-[#d4c8b4] hover:border-[#6a8fc8] hover:text-[#6a8fc8] transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-facebook-line text-base"></i>
                <span className="text-[0.8125rem]">Facebook</span>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-[0.8125rem] font-medium tracking-[0.15em] text-[#baa890] uppercase mb-5">
              <a href="#nav">網站導覽</a>
            </h4>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-[1.0625rem] font-medium text-[#d4c8b4] hover:text-[#f0e8d8] transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[0.8125rem] font-medium tracking-[0.15em] text-[#baa890] uppercase mb-5">
              <a href="#contact">聯絡資訊</a>
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-line-fill text-[#d4c8b4] text-base"></i>
                </div>
                <div>
                  <p className="text-[0.875rem] text-[#baa890] mb-1">LINE 官方帳號</p>
                  <a href="https://line.me" target="_blank" rel="noopener nofollow" className="text-[1rem] text-[#d4c8b4] hover:text-[#f0e8d8] cursor-pointer">@mingzheng</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-map-pin-line text-[#d4c8b4] text-base"></i>
                </div>
                <div>
                  <p className="text-[0.875rem] text-[#baa890] mb-1">教室地址</p>
                  <a
                    href="https://maps.google.com/?q=台中市豐原區豐原大道一段269-1號"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-[0.9375rem] text-[#d4c8b4] hover:text-[#f0e8d8] transition-colors cursor-pointer leading-relaxed"
                  >
                    台中市豐原區<br />豐原大道一段 269-1 號
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-time-line text-[#d4c8b4] text-base"></i>
                </div>
                <div>
                  <p className="text-[0.875rem] text-[#baa890] mb-1">諮詢回覆時間</p>
                  <p className="text-[1rem] text-[#d4c8b4]">週一至週五 10:00–20:00</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#4a3e32] px-6 md:px-12 lg:px-20">
        <div className="overflow-hidden pt-4 pb-0">
          <p className="text-[clamp(2.5rem,8vw,7rem)] font-bold tracking-[0.08em] text-[#3e3028] leading-none select-none whitespace-nowrap">
            MINGZHENG
          </p>
        </div>
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between py-4 gap-2">
          <p className="text-[0.8125rem] text-[#9a8878]">
            &copy; {new Date().getFullYear()} 鳴箏 古箏教學品牌. All rights reserved.
          </p>
          <p className="text-[0.8125rem] text-[#9a8878]">
            古箏教學 &middot; 陪伴式學習 &middot; 選箏諮詢
          </p>
        </div>
        <div className="pb-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <div className="text-center sm:text-left">
            <span className="text-[0.75rem] text-[#8a7d6d]">品牌官網建置｜</span>
            <a
              href="https://vpivip.com/"
              target="_blank"
              rel="noopener nofollow"
              className="text-[0.75rem] text-[#8a7d6d] hover:text-[#baa890] transition-colors cursor-pointer"
            >
              天地人網整合行銷
            </a>
          </div>
          {/* Back to Top Button */}
          <button
            onClick={scrollToTop}
            className="inline-flex items-center gap-1.5 text-[0.8125rem] text-[#9a8878] hover:text-[#d4c8b4] transition-colors cursor-pointer whitespace-nowrap"
            aria-label="回到頂部"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-up-line"></i>
            </div>
            回到頂部
          </button>
        </div>
      </div>
    </footer>
  );
}